export default "__VITE_ASSET__AZWswMPq__"